import {
    createSlice,
    createAsyncThunk,
  } from '@reduxjs/toolkit'
  
  
  const initialState = {
    harvestUpdate: {
      status: "idle",
      success: false,
      error: "",
    },
  }
  
  export const updateData = createAsyncThunk('harvest_update', async (data) => {
      const {token, HarvestId, Quantity, Remark} = data
      let payload = JSON.stringify({
          HarvestId: HarvestId,
          Remark: Remark,
          Quantity: parseInt(Quantity),
      })
      const axios = require("axios")
      const headers = {
                   "Authorization" : `Bearer ${token}`,
                   "Access-Control-Allow-Origin" : "*",
                   "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                }
        const url = `/api/v0/greenhouse/YILI/harvest/yield/remark/update` 
  
        const response = await axios.post(url,
                   payload,
                   { headers })
        return response.data
  })
  
  const harvestUpdateSlice = createSlice({
    name: 'harvest_update',
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
      [updateData.pending.type]:(state, action) => {
        state.harvestUpdate = {
          status: "loading",
          success: false,
          error: "",
        }
      },
      [updateData.fulfilled.type]:(state, action) => {
        state.harvestUpdate = {
          status: "idle",
          success: action.payload.success,
          error: "",
        }
      },
      [updateData.rejected.type]:(state, action) => {
        state.harvestUpdate = {
          status: "idle",
          success: false,
          error: "unauthorized"
        }
      },
    }
  })
  
  export default harvestUpdateSlice.reducer
  